import { render } from "./SimplePage.vue?vue&type=template&id=7f455130&scoped=true"
import script from "./SimplePage.vue?vue&type=script&lang=js"
export * from "./SimplePage.vue?vue&type=script&lang=js"

import "./SimplePage.vue?vue&type=style&index=0&id=7f455130&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f455130"]])

export default __exports__